import * as Config from '../../../config';
import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import '../common/Search.css';

import IconSearch from '../svg/IconSearch'
import IconClear from '../tab-bar/svg/IconClear';

import { setStateShortcuts } from "../shortcut/redux/actions/index";

function FilterPlaylistsInput({ value, onChange, placeholder, showIcon = true, onClear = null, className, style }) {
  const dispatch = useDispatch();
  const [focus, setFocus] = useState(false);
  const prepareFocus = () => {
    setFocus(true);
    dispatch(setStateShortcuts(false));
  }
  const prepareBlur = () => {
    setFocus(false);
    dispatch(setStateShortcuts(true));
  }

  return (
    <div className={`${className} search-box search-filter-playlists flexRow align`} style={{...style}}>
      { showIcon ? (
        <div className="search-icon-v2">
          <IconSearch color={Config.TYPE_PLACEHOLDER } />
        </div>
      ) : null}
      <input className={`search-input filter-playlists type-regular ${(focus || value.length > 0) ? `type-light` : `type-placeholder`} `}
        onFocus={prepareFocus} onBlur={prepareBlur} name={`search-bar`} style={{ }} autoComplete={`off`}
        value={value} onChange={onChange} type="text" placeholder={placeholder}
      />
      { onClear ? (
        <div className="search-clear filter-playlists" onClick={onClear}>
          { value.length > 0 ? <IconClear size={14} className={`icon-clear`} /> : null }
        </div>
      ) : null}
    </div>
  )
}

FilterPlaylistsInput.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
}

export default FilterPlaylistsInput;
